<template>
    <div>
        <div v-if="$store.state.isLoading">
            <loading />
        </div>
        <invoice></invoice>
    </div>
</template>

<script>
import Invoice from '@/components/Administration/InvoiceDemurrage';
import Loading from '@/components/LoadingComponent';

export default {
    name: 'InvoiceDisplay',
    components: {
        Invoice,
        Loading
    }
};
</script>
